import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getChannelById'
})
export class GetChannelByIdPipe implements PipeTransform {

  transform(channelId: number, channels: any[]): any {
    return channels.find(c => c.id === channelId);
  }

}
